let isBrowser = typeof window === "undefined" ? false : true

export default isBrowser
